"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Textarea = _interopRequireDefault(require("./Textarea.style"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var Textarea = function Textarea(_ref) {
  var disabled = _ref.disabled,
    id = _ref.id,
    onBlur = _ref.onBlur,
    placeholder = _ref.placeholder,
    value = _ref.value,
    onChange = _ref.onChange,
    hasErrors = _ref.hasErrors,
    maxLength = _ref.maxLength,
    scrollable = _ref.scrollable,
    className = _ref.className,
    onKeyDown = _ref.onKeyDown,
    ariaLabel = _ref.ariaLabel;
  return /*#__PURE__*/_react["default"].createElement(_Textarea["default"], {
    className: className,
    disabled: disabled,
    placeholder: placeholder,
    id: id,
    onChange: onChange,
    onBlur: onBlur,
    onKeyDown: onKeyDown,
    value: value,
    rows: "1",
    maxLength: maxLength,
    haserrors: hasErrors ? "".concat(hasErrors) : null,
    scrollable: scrollable ? "".concat(scrollable) : null,
    autoComplete: "off",
    "aria-label": ariaLabel || placeholder
  });
};
Textarea.propTypes = {
  hasErrors: _propTypes["default"].bool,
  maxLength: _propTypes["default"].number,
  /**
   * If `true`, the input will be disabled.
   */
  disabled: _propTypes["default"].bool,
  /**
   * The id of the `textarea` element.
   */
  id: _propTypes["default"].string,
  /**
   * @ignore
   */
  onBlur: _propTypes["default"].func,
  /**
   * @ignore
   */
  onChange: _propTypes["default"].func.isRequired,
  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: _propTypes["default"].string,
  /**
   * The input value, required for a controlled component.
   */
  value: _propTypes["default"].string,
  scrollable: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  onKeyDown: _propTypes["default"].func,
  ariaLabel: _propTypes["default"].string
};
Textarea.defaultProps = {
  hasErrors: false,
  maxLength: null,
  disabled: false,
  id: undefined,
  onBlur: undefined,
  onKeyDown: undefined,
  placeholder: '',
  value: '',
  scrollable: false,
  className: '',
  ariaLabel: ''
};
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(Textarea);